module.exports = __webpack_public_path__ + "img/sv2.22cb5edb.svg";